import { render } from "./windows-repair-wrapper.vue?vue&type=template&id=de4ddd32&scoped=true&ts=true"
import script from "./windows-repair-wrapper.vue?vue&type=script&lang=ts"
export * from "./windows-repair-wrapper.vue?vue&type=script&lang=ts"

import "./windows-repair-wrapper.vue?vue&type=style&index=0&id=de4ddd32&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4ddd32"]])

export default __exports__